import { AfterViewInit, Component, OnInit, ViewChild, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthService, BlockAbstractComponent, ParserService } from '@gallaghercp/core-frontend';
import SwiperCore, { Autoplay, Navigation, Pagination, Scrollbar, SwiperOptions } from 'swiper';
import { register } from 'swiper/element';

@Component({
    selector: 'core-block-logo-slider',
    templateUrl: './block-logo-slider.component.html',
    standalone: false,
})
export class BlockLogoSliderComponent extends BlockAbstractComponent implements OnInit, AfterViewInit {
    protected override parser: ParserService;
    protected override auth: AuthService;
    protected breakpoint = inject(BreakpointObserver);

    @ViewChild('logoCarouselSwiper', { static: false }) logoCarouselSwiper: any;

    backgroundImage?: string;
    blockType?: string;
    swiperConfig!: SwiperOptions;

    constructor() {
        const parser = inject(ParserService);
        const auth = inject(AuthService);

        super(parser, auth);

        this.parser = parser;
        this.auth = auth;
    }

    override ngOnInit() {
        super.ngOnInit();

        if (this.isBrowser) {
            SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay]);
        }

        this.swiperConfig = {
            autoplay: this.block.data.options.autoplay ?? false,
            effect: 'slide',
            loop: this.block.data.options.loop ?? false,
            spaceBetween: 32,
            navigation: {
                nextEl: '.jobs-carousel__pagination-next',
                prevEl: '.jobs-carousel__pagination-prev',
            },
            pagination: {
                el: '.jobs-carousel__pagination-bullet',
                clickable: true,
                bulletActiveClass: 'swiper-pagination-bullet--active',
            },
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 5,
                },
            },
        };

        if (this.block.data.type) {
            this.blockType = this.block.data.type.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        }
    }

    ngAfterViewInit(): void {
        if (this.isBrowser) {
            register();
        }
    }
}
